<template>
  <div class="info-modal">
    <div class="close-btn">
      <div style="cursor: pointer" @click.esc="close">x</div>
    </div>

    <div class="error-modal-body">
      <div class="container service-board" v-if="business">
        <div class="text-body">
          <b>
            <h2>“НОМИН БИЗНЕС КАРТ”-ИЙН <br />ХЭРЭГЛЭГЧИЙН ГЭРЭЭ</h2>
          </b>
          <div class="between">
            <p>2023 оны ... сарын ...-ны өдөр</p>
            <p>№</p>
            <p>Улаанбаатар хот</p>
          </div>
          <p>
            &nbsp; &nbsp; Нэг талаас Монгол Улс, Улаанбаатар хот, Хан-Уул
            дүүрэг, 20-р хороо, Чингисийн өргөн чөлөө, Номин Юнайтед цогцолборын
            5 давхарт байрлах ”НОМИН Тав Трейд” ХХК-ийн Картын төв, түүнийг
            төлөөлж захирал С.Ганбаяр /цаашид “Картын төв” гэх/, Нөгөө талаас
            .........................................................................................
            хаягт байрлах “...............................” ХХК, түүнийг төлөөлж
            Гүйцэтгэх захирал
            ................................................... /цаашид
            “Байгууллага” гэх, хамтад нь “Талууд” гэх/ нар Монгол Улсын Иргэний
            хууль, холбогдох бусад хууль тогтоомжийг үндэслэн дараах
            нөхцөлүүдийг харилцан тохиролцсоны үндсэн дээр энэхүү “Хэрэглэгчийн
            гэрээ” /цаашид “Гэрээ” гэх/-г байгуулав
          </p>
        </div>

        <div class="text-body">
          <h2>НЭГ. НИЙТЛЭГ ҮНДЭСЛЭЛ</h2>
          <p>
            1.1 Энэхүү гэрээгээр Байгууллага, түүнийг төлөөлөх эрх бүхий карт
            эзэмшигч ажилтан нь “НОМИН БИЗНЕС КАРТ”-ын үйлчилгээний нөхцөлийн
            дагуу карт нээлгэх, картын мэдээлэл, гүйлгээний хуулга харах, өөрийн
            мэдээллийг засах, хадгалах, “НОМИН Бизнес карт”-ыг /цаашид “Карт”
            гэх/ ашиглан бонус оноо цуглуулах, зарцуулахтай холбогдсон бусад
            харилцааг зохицуулна.
          </p>
          <p>
            1.2 Картын төв нь Байгууллагын бичгээр гаргасан хүсэлтийн үндсэн
            дээр Байгууллагын итгэмжлэгдсэн ажилтанд картыг олгоно.
          </p>
          <p>
            1.3 Энэxүү гэрээний хэрэгжилтэд Картын төв болон Байгууллага xамтран
            xяналт тавина.
          </p>
          <p>
            1.4 Карт нь картын төвийн өмч бөгөөд Байгууллага, түүний төлөөлөх
            эрх бүхий ажилтан нь карт эзэмшигч болно..
          </p>
          <p>
            1.5 Байгууллага, түүнийг төлөөлөх эрх бүхий ажилтан нь
            www.bonus.nomin.mn цахим хуудасыг болон Enomin аппликейшнээр
            дамжуулан картын мэдээлэл, гүйлгээний хуулгыг харна
          </p>
          <p>
            1.6 Картын хувь бонус нь www.bonus.nomin.mn цахим хуудас, Enomin
            аппликейшнд байрлах “НОМИН Бонус картын үйл ажиллагааны журам”-д
            зааснаар болон “Ханган нийлүүлэлтийн хэлтэс”-тэй хийсэн гэрээний
            дагуу бодогдож орно.
          </p>
          <p>1.7 Картын бонусыг мөнгөөр олгохгүй болно.</p>
          <p>
            1.8 Картын “Үйлчилгээний нөхцөл”-ийг энэхүү гэрээний Хавсралт №1-ээр
            тохиролцов. Хавсралтууд нь энэхүү гэрээний салшгүй хэсэг байна.
          </p>
        </div>

        <div class="text-body">
          <h2>ХОЁР. БАЙГУУЛЛАГА, КАРТ ЭЗЭМШИГЧИЙН ЭРХ, ҮҮРЭГ</h2>
          <p>
            2.1.Байгууллага нь түүнийг төлөөлөн байгууллагын картыг эзэмших
            ажилтнуудыг /цаашид “Карт эзэмшигч” гэх/ томилно.
          </p>
          <p>
            2.2 Номин бизнес карт эзэмшигч нь тухайн байгууллагын эрх бүхий
            удирдлагын томилсон 3 хүртэлх итгэмжлэгдсэн ажилтан байж болох ба
            карт эзэмшигч нь картаар бонус оноо хуримтлуулах болон зарцуулалт
            хийх эрхтэй.
          </p>
          <p>
            2.3 Карт эзэмшигч нь шинээр карт хүлээн авахдаа компаниас өгсөн нууц
            кодыг нууцлах үүрэгтэй ба бусдад картаа дамжуулан хэрэглүүлэхийг
            хориглоно.
          </p>
          <p>
            2.4 Kарт эзэмшигч нь гар утас, эсхүл картыг гээсэн, үрэгдүүлсэн,
            xулгайд алдсан тоxиолдолд 1800-2888 лавлах утсанд холбогдон бонусаа
            зарцуулах эрхийг түр хаалгаж, бусдад зүй бусаар ашиглуулахаас
            сэргийлэх үүрэгтэй.
          </p>
          <p>
            2.5 Kарт эзэмшигч нь өөрийн мэдээллийн аюулгүй байдлыг бүрэн xангаx
            үүрэгтэй бөгөөд картын нууц үг, картын төвд бүртгэлтэй утасны
            дугаарыг бусдад шилжүүлэх, ашиглуулахыг хориглоно.
          </p>
          <p>
            2.6 Энэхүү гэрээний 2.3-2.5-д заасан үүргийг Байгууллага болон Карт
            эзэмшигч биелүүлээгүй, зохих ёсоор биелүүлээгүйн улмаас үүсэх
            эрсдэлийг Картын төв хариуцахгүй.
          </p>
          <p>
            2.7 Байгууллагын картыг карт эзэмшигч өөрийн хувийн худалдан авалтад
            ашиглах болон өөр бусад иргэнд дамжуулах замаар тухайн байгууллагад
            хохирол учруулсан тохиолдолд байгууллага Картын төвд хандан картыг
            идэвхигүй болгох, карт эзэмшигчийг солих буюу хасуулах боломжтой ба
            байгууллагад учирсан хохирлыг Картын төв хариуцахгүй.
          </p>
          <p>
            2.8 Байгууллага нь
            <b>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ, ХЭРЭГЛЭГЧИЙН ГЭРЭЭГ УНШИЖ ТАНИЛЦАН ХҮЛЭЭН
              ЗӨВШӨӨРСӨН БОЛНО.</b>
          </p>
        </div>

        <div class="text-body">
          <h2>ГУРАВ. КАРТЫН ТӨВИЙН ЭРХ, ҮҮРЭГ</h2>
          <p>
            3.1 “НОМИН Холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн этгээдүүд,
            болон тэдгээрийн салбар дэлгүүрүүдээс худалдан авсан барааны дүнд
            ногдох бонусыг картын дүрмийн дагуу карт эзэмшигчийн дансанд
            шилжүүлнэ.
          </p>
          <p>
            3.2 “НОМИН Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудаас
            зарласан урамшуулал хөнгөлөлтийн нөхцөлтэй холбоотой үнэн зөв
            мэдээллээр карт эзэмшигчийг хангана.
          </p>
          <p>
            3.3 Бараа буцаалт болон “НОМИН Xолдинг” XXK, түүний нэгдэлд хамаарах
            компаниудаас зарласан бусад төрлийн хөнгөлөлтийг Байгууллага нь
            эдлэх эрхгүй байсан нь тогтоогдсон, давхардсан бол карт эзэмшигчийн
            дансанд орсон бонусыг буцаан байгууллагад мэдэгдэн татах эрхтэй.
            Хэрэв буцаалт хийгдэх үед карт эзэмшигч бонусаа ашигласан буюу карт
            эзэмшигчийн бонус картын үлдэгдэл буцаалт хийх бонусын дүнд хүрэхгүй
            тохиолдолд карт эзэмшигчээр бэлнээр төлүүлнэ.
          </p>
          <p>
            3.4 Гэнэтийн болон давагдашгүй хүчин зүйлсийн улмаас цахилгаан эрчим
            хүч, сүлжээний саатлаас шалтгаалан картаар үйлчлэх боломжгүй нөхцөл
            байдал үүссэн тохиолдолд уншигдаагүй бонусыг нөхөн олгохгүй, мөн
            худалдан авалтын дүн нь нэмэгдэхгүй. Цахилгаан эрчим хүч болон
            сүлжээний саатал нь түр зуурын шалтгаантай саатлаас үүсэн бонус
            нэмэгдээгүй тохиолдлыг карт эзэмшигчийн тухайн салбар нэгжид
            гаргасан хүсэлтийг үндэслэн нөхөж олгож болно.
          </p>
          <p>
            3.5 НОМИН бизнес картаар хувь иргэний худалдан авч буй бараа,
            үйлчилгээний үнийг хөнгөлсөн, бусдын картаар хөнгөлөлт эдлэхийг
            завдсан тохиолдолд картыг хурааж хүчингүй болгох ба бусдын бонусыг
            ашигласан зөрчлийг нөхөн төлүүлэх эрхтэй.
          </p>
          <p>
            3.7 Хувь хүний картыг байгууллагын худалдан авалтанд ашиглаж бонус
            нэмүүлсэн бол тухайн байгууллагын хүсэлтийн дагуу тухайн бонус карт
            ашигласан хэрэглэгчийг идэвхигүй болгох үүрэгтэй.
          </p>
          <p>
            3.8 Эрх бүхий хууль хяналтын байгууллагын албан ёсны шаардлагаар
            гэмт хэрэг, зөрчил шалган шийдвэрлэх ажиллагааны явцад хууль
            сахиулах болон шүүх эрх мэдлийн байгууллагаас албан ёсоор карт
            эзэмшигчийн мэдээллийг шаардсан тохиолдолд зохих мэдээллийг өгнө.
          </p>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>Картын төвийг төлөөлж:</p>
              <!-- <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <p>Нэр: Б.Гэрэлтуяа</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img
                  src="@/assets/Picture1.png"
                  alt=""
                  style="margin-right: 10px"
                />
              </div> -->
            </div>
            <div class="col-md-6">
              <p>Байгууллагыг төлөөлж:</p>
              <p>“................................” ХХК</p>
              <p>Нэр: {{ this.loginLastName + " " + this.loginFirstName }}</p>
              <p>Албан тушаал:</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <p></p>
            <p class="padding">
              ........... тоот “НОМИН Бизнес Карт”-ын Хэрэглэгчийн гэрээний
              Хавсралт №1
            </p>
          </div>
        </div>
        <div class="text-body">
          <h2>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h2>
          <p>
            1. НОМИН БИЗНЕС КАРТ нь Аж ахуйн нэгжид зориулсан Хөнгөлөлтийн карт
            бөгөөд карт нь “Бизнес бонус халаас” /Business bonus pocket/,
            “Бизнес гишүүнчлэлийн халаас” /Business membership pocket/ гэсэн
            хоёр халаасыг нэг картан дээр агуулсан бүтээгдэхүүн юм. НОМИН БИЗНЕС
            КАРТ нь дараах төрөлтэй байна. Үүнд:
          </p>
          <p>
            &nbsp; &nbsp; 1.1.Бизнес бонус карт: 1%-10% хүртэл хувь өсдөг
            худалдан авалт бүрээс бонус зарцуулж, цуглуулах, үйлчилгээний үнийн
            дүнгийн 50 хүртэлх хувьд зарцуулан хөнгөлөлт эдлэх боломжтой.
          </p>
          <p>
            &nbsp; &nbsp; 1.2.Бизнес гишүүнчлэлийн карт: Номин бизнес клуб буюу
            Улаанбаатар импекс салбараас хийсэн худалдан авалт бүрээсээ 2%-ийн
            бонус цуглуулах боломжтой бөгөөд цуглуулсан бонусаа улиралдаа 1 удаа
            худалдан авалтандаа 100 хувь ашиглах боломжтой.
          </p>
          <p>
            2. Байгууллага нь энэхүү гэрээгээр “НОМИН Xолдинг” XXK, түүний
            нэгдэлд хамаарах компаниудад Байгууллага болон түүнийг төлөөлөх эрх
            бүхий карт эзэмшигчийн хуулиар зөвшөөрөгдсөн мэдээллийг цуглуулаx,
            боловсруулаx, ашиглаx, дамжуулаx зөвшөөрлийг олгож байгаа болно
          </p>
          <p>
            3. Kарт эзэмшигч нь www.bonus.nomin.mn, Еnomin аппликейшнд
            нэвтэрснээр Бонус оноо цуглуулах, зарцуулах, гүйлгээний хуулга
            харах, үлдэгдэл оноо шалгах, урамшуулалт хөтөлбөрүүдэд хамрагдах,
            бүтээгдэхүүн үйлчилгээний талаар мэдээлэл авах боломжтой болно.
          </p>
          <p>
            4. Kарт эзэмшигч нь бонус оноо цуглуулах, зарцуулахдаа пин код /4
            оронтой тоо/ ашиглана. www.bonus.nomin.mn, Enomin аппликейшн-ээр
            нэвтрэн гүйлгээний пин кодоо өөрчлөх боломжтой.
          </p>
          <p>
            5. Kарт эзэмшигч нь “НОМИН Холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн
            этгээдүүд, болон тэдгээрийн салбар дэлгүүрүүдээс худалдан авалт хийх
            үедээ 1 бонус оноо =1 төгрөг зарчмаар бонус оноогоор бүтээгдэхүүн,
            үйлчилгээг авна.
          </p>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>Картын төвийг төлөөлж:</p>
              <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <!-- <p>Нэр: Б.Гэрэлтуяа</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img
                  src="@/assets/Picture1.png"
                  alt=""
                  style="margin-right: 10px"
                />
              </div> -->
            </div>
            <div class="col-md-6">
              <p>Байгууллагыг төлөөлж:</p>
              <p>“................................” ХХК</p>
              <p>Нэр: {{ this.lastName + " " + this.firstName }}</p>
              <p>Албан тушаал:</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
      </div>
      <div class="service-board" v-else>
        <div class="text-body">
          <h2>“НОМИН БОНУС ЛОЯАЛТИ ХӨТӨЛБӨР”-ИЙН ХЭРЭГЛЭГЧИЙН ГЭРЭЭ</h2>
        </div>

        <div class="text-body">
          <h2>НЭГ. ГЭРЭЭНИЙ ЗҮЙЛ</h2>
          <p>
            1.1 Энэxүү үйлчилгээний нөxцөлийн хэрэгжилтэд “Номин Тав Трейд” XXK-ийн Картын төв /цаашид “Компани” гэx/
            болон карт эзэмшигч xамтран хяналт тавина.
          </p>
          <p>
            1.2 Компани нь хэрэглэгчийн хүсэлтээр бонус карт /цаашид "карт" гэх/ олгох, үйлчилгээ үзүүлэх, картаа
            ашиглан бонус оноо цуглуулах, зарцуулахтай холбогдон үүсэх талуудын эрх, үүрэг, хариуцлагыг тодорхойлох
            харилцааг зохицуулахад уг гэрээний зорилго оршино.
          </p>
          <p>
            1.3 Карт нь компанийн өмч бөгөөд картын хувь болон бонус нь Картын төвийн үйл ажиллагааны журамд зааснаар
            бодогдож орно.
          </p>
          <p>1.4 Картын бонусыг мөнгөөр олгохгүй болно.</p>
        </div>

        <div class="text-body">
          <h2>ХОЁР. ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h2>
          <p>
            2.1 Карт эзэмшигч нь бонус картыг Номингийн аль ч салбар дэлгүүрт өөрийн биеэр очиж нээлгэх эсхүл
            card.nomin.mn, nomin аппликейшн ашиглан бүртгүүлж үйлчилгээ авах бөгөөд “Номин Тав Трейд” ХХК-ийн толгой
            компани болох “Номин Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудад карт эзэмшигчийн шаардлагатай
            мэдээллийг цуглуулаx, боловсруулаx, ашиглаx, дамжуулаxыг зөвшөөрсний үндсэн дээр гэрээ байгуулагдана.
          </p>
          <p>
            2.2 Карт эзэмшигчийн сүүлийн 2 жилийн худалдан авалтын дүнгээр картын хувь тодорхойлогдож, 3-10% хүртэл өсөж
            буурах бөгөөд картын хувь тооцох интервалыг эдийн засгийн өсөлт, инфляцын түвшинтэй уялдуулан 2 жил тутамд
            шинэчлэн тогтооно.
          </p>
          <p>
            2.3 “Юнайтед Аллианс” ХХК-тай хамтын ажиллагааны дагуу карт эзэмшигчийн хүсэлтээр Ю-Пойнт карт ашиглах
            боломжийг нээж өгөх бөгөөд, Ю-Пойнт оноо ашиглаж байгаа үед “Юнайтед Аллианс” ХХК-ийн хэрэглэгчтэй
            байгуулсан гэрээний дагуу үйл ажиллагааг хөтөлнө. Карт эзэмшигч нь Ю-Пойнт картыг Номин Бонус карттай
            холбосон бол бонус картын нийт хувиас 3%-ир Ю-Пойнт оноо олгоно.
          </p>
          <p>
            2.4 Kарт эзэмшигч нь Nomin аппликейшнд нэвтэрснээр картын мэдээлэл харах, засах, хамтран эзэмшигч нэмэх,
            хасах, өөрийн болон хамтран эзэмшигчийн гүйлгээний хуулга харах, бонус оноогоо цуглуулах, зарцуулах,
            шилжүүлэх, үлдэгдэл оноогоо шалгах, урамшуулалт хөтөлбөрүүдэд хамрагдах, бүтээгдэхүүн үйлчилгээний талаар
            мэдээлэл авах, санал хүсэлтээ илгээх боломжтой болно.
          </p>
          <p>
            2.5 Kарт эзэмшигч нь бонус оноогоо цуглуулах, зарцуулахдаа пин код /4 оронтой тоо/ ашиглана. bonus.nomin.mn,
            nomin аппликейшн-аар нэвтрэн гүйлгээний пин кодоо өөрчлөх боломжтой.
          </p>
          <p>
            2.6 Kарт эзэмшигч нь Номингийн салбар дэлгүүрүүд болон “Номин холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн
            этгээдээс худалдан авалт хийх үедээ үнийн дүнгийн 50% хүртэлх дүнд 1 бонус оноо = 1 төгрөг зарчмаар бонус
            оноогоо зарцуулан хөнгөлөлт эдлэх боломжтой.
          </p>
          <p>
            2.7 Компани нь карт эзэмшигчдэд хөнгөлөлт, урамшуулал, нэмэлт үйлчилгээ үзүүлсний төлбөрийг сар бүр карт
            эзэмшигчдийн данснаас суутгана. Карт эзэмшигчийн дансны үлдэгдэл хүрэлцэхгүй тохиолдолд тухайн сардаа
            шимтгэлийн дүнд хүртэл үлдэгдэл бонусыг давтан суутгал хийнэ.
          <ul>
            <li>
              Номин бонус 3%-тай хэрэглэгчээс 600 бонус /Юпойнттой нэгдээгүй Номин бонус 3%-тай карт хэрэглэгч нараас
            </li>
            <li>
              Номин бонус 4%-тай хэрэглэгчээс 1200
            </li>
            <li>
              Номин бонус 5%-тай хэрэглэгчээс 1500
            </li>
            <li>
              Номин бонус 6%-тай хэрэглэгчээс 1800
            </li>
            <li>
              Номин бонус 7%-тай хэрэглэгчээс 2100
            </li>
            <li>
              Номин бонус 8%-тай хэрэглэгчээс 2400
            </li>
            <li>
              Номин бонус 9%-тай хэрэглэгчээс 2700
            </li>
            <li>
              Номин бонус 10%-тай хэрэглэгчээс 3000
            </li>
          </ul>
          </p>
          <p>
            2.8 НОМИН бонус карт 3 хувиас 10 хувь хүртэл оноо хуримтлуулах боломжтой карт. Картын хувийг хэрэглэгчийн
            сүүлийн 2 жил буюу 730 хоногийн худалдан авалтын дүнгээр тооцно.
          </p>
          <p>2.9 НОМИН бонус, U-point оноо,барааны бонус, ваучер, купон ашиглах нөхцөл.</p>
          <p>2.9.1 Барааны бонустай үед барааны үнээс барааны бонус, ашигласан НОМИН бонус болон ашигласан U-point оноог
            хасаж үлдэгдэл бэлэн төлсөн дүнгээс картын хувиар НОМИН бонус болон U-point оноог тооцон олгоно.</p>
          <p>2.9.2 Бонус хасагдах дараалал нь:
            <br>&nbsp;&nbsp; 1. U-point оноо
            <br>&nbsp;&nbsp; 2. Барааны бонус
            <br>&nbsp;&nbsp; 3. НОМИН бонус гэсэн дарааллаар хасагдана.
          </p>
          <p>
            2.10 Бөөний болон багцын худалдан авалт хийхээс бусад худалдан авалт дээр бонус оноо нэмэгдэнэ.
          </p>
          <p>2.11 Компани 5-аас дээш жил ашиглаагүй картыг жилд нэг удаа нэгдсэн байдлаар идэвхгүй болгоно.</p>
          <p>2.12 НОМИН бонус карт эзэмшигч нь Финтек буюу BNPL / 3-6 хуваан төлөх / нөхцөлөөр “НОМИН Холдинг” ХХК,
            түүний нэгдэлд хамаарах хуулийн этгээдүүдээс бараа бүтээгдэхүүн худалдан авсан тохиолдолд картын хувийн
            50%-д бонус олгоно.</p>
          <p>2.13 НОМИН аппликейшн болон биет бонус карт ашиглах боломжгүй үед хэрэглэгчийг нэг удаагийн тан кодоор
            баталгаажуулах ба данснаас 49₮-ийг суутгана.
          </p>
          <p>2.14 Карт эзэмшигчдэд хөнгөлөлт, урамшуулал, нэмэлт үйлчилгээ үзүүлсний төлбөрийг бонус онооны үлдэгдлээс
            суутгана. Үндсэн бонусын үлдэгдэл хүрэлцэхгүй тохиолдолд журмын бонусаас суутгана.</p>
          <p>2.15 Карт эзэмшигч нь “Номин Тав Трейд” ХХК-тай хамаарал бүхий “НОМИН Юнити” ББСБ-аас “OmniWay”
            аппликэйшнээр дамжуулан авсан финтек зээлийн гэрээний үүргээ биелүүлээгүй тохиолдолд Номин бонус карт
            эзэмших, ашиглах, захиран зарцуулах нөхцөлд дараах хязгаарлалт тавигдахыг үүгээр хүлээн зөвшөөрөв. Үүнд:
            <br>&nbsp;&nbsp; 2.15.1 Карт эзэмшигч Зээлийн гэрээнд заасан хугацаанд зээл болон хүүгийн төлбөрийг төлөөгүй
            тохиолдолд, хугацаа хэтэрсэн 31 дэх өдрөөс карт эзэмшигчийн нэр дээр бүртгэлтэй Номин бонус карт блоклогдож,
            зөвхөн бонус оноо хуримтлагдах ба зарцуулах боломжгүй болно.
            <br>&nbsp;&nbsp; 2.15.2 Карт эзэмшигч нь Зээлийн гэрээний үүргээ үл биелүүлж, зээлийн төлбөрийг 90 хоногоос
            дээш хугацаагаар төлөөгүй тохиолдолд карт эзэмшигчийн нэр дээр бүртгэлтэй Номин бонус картад хуримтлагдсан
            оноог компани суутган авах эрхтэй.
          </p>
        </div>

        <div class="text-body">
          <h2>ГУРАВ. КАРТ ЭЗЭМШИГЧИЙН ЭРХ ҮҮРЭГ</h2>
          <p>
            3.1 Карт эзэмшигч нь “НОМИН бонус лояалти хөтөлбөрийн гэрээ”-н дагуу үйлчилгээ авах эрхтэй.
          </p>
          <p>
            3.2 Карт эзэмшигч нь “Гүйлгээний пин код” болон онлайн системүүдэд нэвтрэх “Нэвтрэх нууц үг”-н нууцлалыг
            хамгаалах үүрэгтэй. Хэрэглэгч хувийн мэдээллийн нууцлалыг алдсанаас үүсэх хохирлыг компани хариуцахгүй.
          </p>
          <p>
            3.3 Шинээр карт эзэмшигч болсон хэрэглэгч bonus.nomin.mn вэб сайт руу гүйлгээний пин кодоор нэвтрэн нэвтрэх
            нууц кодыг өөрчлөх, гэрээг хүлээн зөвшөөрөх үүрэгтэй.
          </p>
          <p>
            3.4 Үйлчилгээний нөхцөл, түүний нэмэлт өөрчлөлт болон картын хувийн өөрчлөлтийн талаарх мэдээлэл, дансны
            хуулгаа bonus.nomin.mn вэб сайтаар хандан танилцаж, хяналт тавьж байх үүрэгтэй.
          </p>
          <p>
            3.5 Картаа гээсэн, хулгайд алдсан тохиолдолд нэн даруй 1800-2888 тусгай дугаарт өөрийн бүртгэлтэй ID
            дугаараас холбогдож компанийн картын төвд мэдэгдэж, идэвхгүй болгуулах үүрэгтэй ба картыг идэвхгүй
            болгоогүйгээс үүссэн хохирлыг карт эзэмшигч өөрөө бүрэн хариуцна.
          </p>
          <p>
            3.6 Үндсэн карт эзэмшигч нь өөрийн дансанд дахь бонус, хамтран эзэмшигчдийн төлбөр, тооцоог бүрэн хариуцаж,
            хянах үүрэгтэй.
          </p>
          <p>
            3.7 Карт эзэмшигчийн хувийн мэдээлэл, таних мэдээлэлд өөрчлөлт орсон тохиолдолд bonus.nomin.mn веб сайт
            эсвэл өөрийн биеэр бичиг баримттайгаа карт бүртгэлийн ажилтанд хандан мэдээллээ шинэчлэх үүрэгтэй.
          </p>
          <p>
            3.8 “НОМИН Холдинг” ХХК түүний нэгдэлд багтах хуулийн этгээдүүд, НОМИН картын системд холбогдсон бусад
            компани, аж ахуйн нэгж мөн U-point хөтөлбөрт нэгдсэн байгууллагуудаар үйлчлүүлэгч, үйлчлүүлэхийг хүсэгч
            иргэн, байгууллага нь U-point болон НОМИН карт эзэмших эрхтэй.
          </p>
          <p>
            3.9 Карт эзэмшигчээр бүртгүүлэхдээ “НОМИН лояалти хөтөлбөрийн гэрээ”-г хүлээн зөвшөөрөх ба өөрийн хүсэлтээр
            үйлчилгээнээс татгалзах эрхтэй.
          </p>
          <p>
            3.10 Карт эзэмшигч нь НОМИН бонус картыг биет болон цахим хэлбэрээр эзэмших боломжтой.
          </p>
          <p>
            3.11 Карт эзэмшигч нь “НОМИН Юнити” ББСБ-аас “OmniWay” аппликэйшнээр дамжуулан финтек зээл авсан тохиолдолд
            зээлийн гэрээнд заасан хугацааны дагуу үндсэн зээл болон зээлийн хүүгийн төлбөрийг бүрэн төлөх үүрэгтэй ба
            энэ үүргээ биелүүлээгүй тохиолдолд энэхүү гэрээнд заасан нөхцөлийн дагуу Номин бонус карт эзэмших, ашиглах,
            захиран зарцуулах эрх хязгаарлагдана.
          </p>
        </div>

        <div class="text-body">
          <h2>ДӨРӨВ. КОМПАНИЙН ЭРХ ҮҮРЭГ</h2>
          <p>
            4.1 Компаниас худалдан авсан барааны дүнд ногдох бонусыг картын дүрмийн дагуу карт эзэмшигчийн дансанд
            шилжүүлж байх үүрэгтэй.
          </p>
          <p>
            4.2 “Номин Тав Трейд” ХХК-ийн толгой компани болох “Номин Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудаас
            зарласан урамшуулал хөнгөлөлтийн нөхцөлтэй холбоотой үнэн зөв мэдээллээр карт эзэмшигчийг хангана.
          </p>
          <p>
            4.3 Бараа буцаалт болон компанийн нэгдэлд хамаарах компаниудаас зарласан бусад төрлийн хөнгөлөлттэй давхар
            хөнгөлөлт үзүүлэх ёсгүй байсан нь тогтоогдсон, давхардсан бол карт эзэмшигчийн дансанд орсон тохиолдолд
            бонусыг буцаан авах эрхтэй. Хэрэв буцаалт хийгдэх үед карт эзэмшигч бонусаа ашигласан буюу карт эзэмшигчийн
            бонус картын үлдэгдэл буцаалт хийх бонусын дүнд хүрэхгүй тохиолдолд карт эзэмшигчээр бэлнээр төлүүлнэ.
          </p>
          <p>
            4.4 Компанийн үйл ажиллагаанаас үл шалтгаалах гэнэтийн болон давагдашгүй хүчин зүйлийн улмаас цахилгаан
            эрчим хүч, программ хангамж, сүлжээний саатлаас шалтгаалан картаар үйлчлэх боломжгүй нөхцөл байдал үүссэн
            тохиолдолд бонусыг нөхөн олгохгүй мөн худалдан авалтын дүнг нэмэхгүй байх эрхтэй.
          </p>
          <p>
            4.5 Картын төвийн дарга болон менежерүүд карттай гүйлгээ, карт эзэмшигчтэй холбоотой шаардлагатай мэдээллийг
            зөвхөн дотооддоо ашиглах эрхтэй.
          </p>
          <p>
            4.6 “НОМИН бонус болон Юпойнт хөтөлбөр”-т нэгдсэн гишүүн байгууллагуудаар үйлчлүүлэх боломжийг нэмэгдүүлэх,
            гишүүн байгууллагуудын бүтээгдэхүүн, үйлчилгээг сайжруулах, хөгжүүлэлт хийх, хэрэглэгчид урамшуулал санал
            болгох зорилгоор гишүүн байгууллагуудад хэрэглэгчийн өөрийн зөвшөөрлөөр мэдээллийг дамжуулж болно.
          </p>
          <p>
            4.7 Гэмт хэрэг, зөрчил шалган шийдвэрлэх ажиллагааны явцад хууль сахиулах болон шүүх эрх мэдлийн
            байгууллагаас албан ёсоор шаардсан тохиолдолд карт эзэмшигчийн мэдээлэл, бүтээгдэхүүн үйлчилгээ, хөнгөлөлт,
            урамшууллын түүхийн талаарх мэдээллийг өгч болно.
          </p>
        </div>

        <div class="text-body">
          <h2>
            “НОМИН БОНУС ЛОЯАЛТИ ХӨТӨЛБӨР”-ИЙН НӨХЦӨЛ, ХЭРЭГЛЭГЧИЙН ГЭРЭЭГ УНШИЖ
            ТАНИЛЦАН ХҮЛЭЭН ЗӨВШӨӨРЧ БАЙНА.
          </h2>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <p>Нэр:Э.Тамир</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img src="@/assets/Picture2.png" alt="" style="margin-right: 10px" />
              </div>
            </div>
            <div class="col-md-6">
              <p>
                Үйлчилгээг xүлээн зөвшөөрсөн: <i class="fa fa-check-circle"></i>
              </p>
              <p>Нэр: {{ this.loginLastName + " " + this.loginFirstName }}</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
      </div>

      <div class="service-confirm">
        <b-form-checkbox id="checkbox-1" v-model="isChecked" name="checkbox-1" value="true" unchecked-value="false">
          Би үйлчилгээний нөхцлийг зөвшөөрч байна.
        </b-form-checkbox>
      </div>

      <div class="container" v-if="user.IsConfirmInformation == 0">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6 row">
                <div class="col-md-12 box-text">
                  <h2 class="head">Карт эзэмшигчийн мэдээлэл:</h2>
                </div>

                <div class="col-md-12 row box-text" v-if="bonus">
                  <div class="col-md-6">
                    <h2>Овог:</h2>
                  </div>

                  <div class="col-md-6">
                    <p v-if="
                      typeof user.lastName !== 'undefined' &&
                      user.lastName !== 'null' &&
                      user.lastName !== ''
                    ">
                      {{ user.lastName }}
                    </p>
                    <p v-else>
                      <input type="text" class="form-control col-md-12" v-model="lastname" />
                    </p>
                  </div>
                </div>

                <div class="col-md-12 row box-text">
                  <div class="col-md-6">
                    <h2>Нэр:</h2>
                  </div>

                  <div class="col-md-6">
                    <p v-if="
                      typeof user.firstName !== 'undefined' &&
                      user.firstName !== 'null' &&
                      user.firstName !== ''
                    ">
                      {{ user.firstName }}
                    </p>
                    <p v-else>
                      <input type="text" class="form-control col-md-12" v-model="firstname" />
                    </p>
                  </div>
                </div>

                <div class="col-md-12 row box-text">
                  <div class="col-md-6">
                    <h2>Регистрийн дугаар:</h2>
                  </div>

                  <div class="col-md-6">
                    <p v-if="
                      typeof user.customerRegNo !== 'undefined' &&
                      user.customerRegNo !== ''
                    ">
                      {{ user.customerRegNo }}
                    </p>
                    <p v-else style="display: flex; flex-direction: row">
                      <select class="form-control" style="
                          width: 20%;
                          margin-right: 5%;
                          padding: 0 !important;
                        " name="regFirst" v-model="regFirst">
                        <option v-for="data in letters" :value="data.value" :key="data.value">
                          {{ data.name }}
                        </option>
                      </select>
                      <select class="form-control" style="
                          width: 20%;
                          margin-right: 5%;
                          padding: 0 !important;
                        " name="regSecond" v-model="regSecond">
                        <option v-for="data in letters" :value="data.value" :key="data.value">
                          {{ data.name }}
                        </option>
                      </select>
                      <input type="number" class="form-control col-md-6" v-model="regThird" />
                    </p>
                  </div>
                </div>

                <div class="col-md-12 row box-text">
                  <div class="col-md-6">
                    <h2>Картын дугаар:</h2>
                  </div>

                  <div class="col-md-6">
                    <p>{{ user.cardId }}</p>
                  </div>
                </div>
              </div>

              <div class="col-md-6 row">
                <div class="col-md-12 box-text">
                  <h2 class="head">Баталгаажуулах мэдээлэл:</h2>
                </div>

                <div class="col-md-12 row">
                  <div class="col-md-12 row box-text">
                    <div class="col-md-6">
                      <h2>Утасны дугаар:</h2>
                    </div>

                    <div class="col-md-6">
                      <div class="user-id">
                        <div class="">{{ user.idPhone }}</div>
                        <img src="@/assets/icon/edit-b.png" alt="" @click="idNumber()" />
                        <span @click="idNumber()">өөрчлөх</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 row box-text">
                    <div class="col-md-6">
                      <h2>Бусад утасны дугаар:</h2>
                    </div>

                    <div class="col-md-6">
                      <p>
                        <input type="text" class="form-control col-md-12" v-model="phone2" />
                      </p>
                    </div>
                  </div>

                  <div class="col-md-12 row box-text">
                    <div class="col-md-6">
                      <h2>Имэйл хаяг:</h2>
                    </div>

                    <div class="col-md-6">
                      <p>
                        <input type="text" class="form-control col-md-12" v-model="email" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 box-info">
          <p class="my-info" v-if="isPosCardConfirm == 0">
            Та мэдээллээ үнэн зөв бөглөнө үү
          </p>
          <p class="my-info" v-else>
            Та өөрийн мэдээллээ үнэн зөв эсэхийг шалгана уу. Хэрэв зөрүүтэй бол
            Номин картын төвийн ажилтантай холбогдоно уу. Утас: 1800-2888
          </p>
        </div>
      </div>
      <div class="container col-md-12 box-text top20">
        <div class="col-md-12 text-right">
          <button class="btn" @click.esc="sendConfirm" :disabled="inProcess">
            Баталгаажуулах
          </button>
          <button class="btn redColor" @click.esc="close">Болих</button>
        </div>
      </div>
      <!-- </div> -->
    </div>

    <transition name="fade">
      <Number @setNumber="setNumber" v-if="checkNumber" :phone="user.idPhone"></Number>
    </transition>

    <transition name="fade">
      <Error :errorMessage="errorMessage" v-if="errorModal" @hideErrorMessage="hideErrorMessage"></Error>
    </transition>
  </div>
</template>

<script>
import Number from "../user/number/main";
import Error from "@/views/plugin/error";
import { Service } from "@/mixins/Service";
import { User } from "@/mixins/User";
import letterJSON from "@/json/data.vue";
export default {
  data() {
    return {
      phone: "",
      phone2: "",
      email: "",
      firstname: null,
      lastname: null,
      regFirst: null,
      regSecond: null,
      regThird: null,
      registerno: null,
      inProcess: false,
      checkNumber: false,
      serviceData: {},
      user: {},
      isChecked: false,
      errorMessage: "",
      errorModal: false,
      IsConfirmedInformation: 0,
      IsConfirmAgreement: 0,
      loader: false,
      letters: letterJSON.myJson,
      isPosCardConfirm: 0,
      bonus: false,
      loginLastName: "",
      loginFirstName: "",
      business: false,
    };
  },
  mixins: [Service, User],
  methods: {
    setNumber(phoneNumber) {
      this.phone = phoneNumber;
    },
    close() {
      this.$emit("hideInfoModal");
    },
    getUser() {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }

      var customerInfo = this.$auth.getCardInfo();
      this.user = customerInfo;
      this.phone2 = customerInfo.customerPhone;
      this.email = customerInfo.customerEMail;
      this.firstname =
        customerInfo.firstName == "null" ? "" : customerInfo.firstName;
      this.lastname =
        customerInfo.lastName == "null" ? "" : customerInfo.lastName;
      this.registerno = customerInfo.customerRegNo;
      this.isPosCardConfirm = customerInfo.isPosCardConfirm;
      this.IsConfirmAgreement = customerInfo.IsConfirmAgreement;
      this.isConfirmInformation = customerInfo.IsConfirmInformation;

      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var resultInfo = response.data;
          if (resultInfo.status === 0) {
            if (resultInfo.CartType === "Business") {
              this.business = true;
            }
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    sendConfirm() {
      if (this.isChecked == "true") {
        //Бизнес карт
        if (this.bonus == false) {
          if (this.phone2 !== null) {
            if (this.email !== null) {
              if (this.firstname != "") {
                let phone = this.phone2;
                let firstname = this.firstname;
                let email = this.email;
                let registerno = this.registerno;
                let tokenId = localStorage.getItem("authToken");
                let userData = this.$auth.getMe();
                let IsConfirmedInformation = this.isChecked ? 1 : 0;
                let IsConfirmAgreement = this.isChecked ? 1 : 0;

                if (tokenId == null || userData == null) {
                  this.RedirectLogin();
                  this.$auth.destroyToken();
                  this.$auth.removeMe();
                  this.$router.push({ name: "login" });
                }
                let cardHolderInfId = userData.cardHolderInfId;
                const checkResponse = this.checkByRegister(registerno);
                checkResponse.then((checkRes) => {
                  if (checkRes.status !== true || this.isPosCardConfirm == 1) {
                    this.$axiosApi
                      .post(`card/update/holder/confirmOn`, {
                        tokenId,
                        cardHolderInfId,
                        phone,
                        email,
                        firstname,
                        registerno,
                        IsConfirmedInformation,
                        IsConfirmAgreement,
                      })
                      .then((response) => {
                        var result = response.data;

                        if (result.status === 0) {
                          this.isDisabled = false;
                          this.changeCardInfo();
                          this.$emit("showSuccessMessage", result.message);
                          this.$emit("hideInfoModal");
                        } else if (result.status === 100) {
                          this.errorMessage = response.data.message;
                          this.errorModal = true;
                          this.isDisabled = false;
                        } else if (result.status === 201) {
                          this.RedirectLogin();
                          this.$auth.destroyToken();
                          this.$auth.removeMe();
                          this.$router.push({ name: "login" });
                        }
                      })
                      .catch(() => {
                        this.RedirectLogin();
                        this.$auth.destroyToken();
                        this.$auth.removeMe();
                        this.$router.push({ name: "login" });
                      });
                  } else {
                    this.errorModal = true;
                    this.errorMessage =
                      "Таны оруулсан регистр бүртгэлтэй байна ?";
                  }
                });
              } else {
                this.errorModal = true;
                this.errorMessage =
                  "Биенес карт эзэмшигчийн нэрээ оруулна уу ?";
              }
            } else {
              this.errorModal = true;
              this.errorMessage = "Та имэйл талбарыг бөглөнө үү ?";
            }
          } else {
            this.errorModal = true;
            this.errorMessage = "Та бусад утасны дугаар талбарыг бөглөнө үү ?";
          }
        }
        //Бонус карт
        else {
          if (this.phone2 !== null) {
            if (this.email !== null) {
              if (this.firstname != "" && this.lastname != "") {
                if (
                  (this.regFirst != null &&
                    this.regSecond != null &&
                    this.regThird != null) ||
                  this.registerno != null
                ) {
                  if (
                    this.regFirst != null &&
                    this.regSecond != null &&
                    this.regThird != null
                  ) {
                    this.registerno =
                      this.regFirst + this.regSecond + this.regThird;
                  }

                  let phone = this.phone2;
                  let firstname = this.firstname;
                  let lastname = this.lastname;
                  let email = this.email;
                  let registerno = this.registerno;
                  let tokenId = localStorage.getItem("authToken");
                  let userData = this.$auth.getMe();
                  let IsConfirmedInformation = this.isChecked ? 1 : 0;
                  let IsConfirmAgreement = this.isChecked ? 1 : 0;

                  if (tokenId == null || userData == null) {
                    this.RedirectLogin();
                    this.$auth.destroyToken();
                    this.$auth.removeMe();
                    this.$router.push({ name: "login" });
                  }
                  let cardHolderInfId = userData.cardHolderInfId;
                  const checkResponse = this.checkByRegister(registerno);
                  checkResponse.then((checkRes) => {
                    if (
                      checkRes.status !== true ||
                      this.isPosCardConfirm == 1
                    ) {
                      this.$axiosApi
                        .post(`card/update/holder/confirmOn`, {
                          tokenId,
                          cardHolderInfId,
                          phone,
                          email,
                          firstname,
                          lastname,
                          registerno,
                          IsConfirmedInformation,
                          IsConfirmAgreement,
                        })
                        .then((response) => {
                          var result = response.data;

                          if (result.status === 0) {
                            this.isDisabled = false;
                            this.changeCardInfo();
                            this.$emit("showSuccessMessage", result.message);
                            this.$emit("hideInfoModal");
                          } else if (result.status === 100) {
                            this.errorMessage = response.data.message;
                            this.errorModal = true;
                            this.isDisabled = false;
                          } else if (result.status === 201) {
                            this.RedirectLogin();
                            this.$auth.destroyToken();
                            this.$auth.removeMe();
                            this.$router.push({ name: "login" });
                          }
                        })
                        .catch(() => {
                          this.RedirectLogin();
                          this.$auth.destroyToken();
                          this.$auth.removeMe();
                          this.$router.push({ name: "login" });
                        });
                    } else {
                      this.errorModal = true;
                      this.errorMessage =
                        "Таны оруулсан регистр бүртгэлтэй байна ?";
                    }
                  });
                } else {
                  this.errorModal = true;
                  this.errorMessage = "Та регистрийн дугаараа оруулна уу ?";
                }
              } else {
                this.errorModal = true;
                this.errorMessage = "Та овог, нэрээ оруулна уу ?";
              }
            } else {
              this.errorModal = true;
              this.errorMessage = "Та имэйл талбарыг бөглөнө үү ?";
            }
          } else {
            this.errorModal = true;
            this.errorMessage = "Та бусад утасны дугаар талбарыг бөглөнө үү ?";
          }
        }
      } else {
        this.errorModal = true;
        this.errorMessage = "Та үйлчилгээний нөхцөлийг зөвшөөрсөн үү ?";
      }
    },
    hideErrorMessage() {
      this.errorMessage = "";
      this.errorModal = false;
    },
    changeCardInfo() {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();

      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          {
            tokenId: tokenId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            //remove cardInfo
            this.$auth.removeCardInfo();
            //set cardInfo
            this.$auth.setCardInfo(result);
          } else if (result.status === 201) {
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    // bonusTransfer(){
    //     this.inProcess = true;
    //     this.$emit('bonusTransfer');
    // }
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
      this.loginLastName = cardHolderInfo.lastName;
      this.loginFirstName = cardHolderInfo.firstName;
    },
  },
  created() {
    this.getUser();
    this.fetchData();
    this.cardInfoList();
  },
  components: {
    Number,
    Error,
  },
};
</script>
<style scoped>
.my-info {
  margin: 5px 20px !important;
  padding: 5px 20px !important;
  border: 1px solid #1660ab85;
  background: rgb(199 193 193 / 9%);
  color: black !important;
  font-weight: 300;
  font-size: 13px !important;
  text-align: center;
}

.my-info::before {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  display: block;
  left: 50%;
  top: -10px;
  border-bottom-color: #08c;
}

.row {
  margin-right: 0;
}

.close-btn {
  position: absolute;
  color: #fff;
  flex-direction: row;
  justify-content: flex-end;
  /* width: 100%; */
  padding: 0 10px;
  font-size: 28px;
  right: 0;
  top: 0;
}

.service-confirm {
  text-align: right;
  width: 100%;
  padding: 0 10px;
  font-size: 13px;
  line-height: 2;
  color: #1660ab;
  margin-bottom: 10px;
}

.service-confirm input {
  margin-right: 5px;
  outline: 1px solid #ddd;
}

p input {
  font-size: 13px;
}

.text-right {
  text-align: right;
}

.user-id {
  height: 30px;
  flex: 2;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.user-id div {
  padding: 0.375rem 0.75rem;
  width: 149px;
  height: 30px;
  mix-blend-mode: multiply;
  border-radius: 3px;
  background-color: #ebebeb;
  font-size: 12px;
}

.user-id img {
  margin-left: 13px;
  width: 17px;
  height: 16px;
  display: flex;
  align-self: center;
  cursor: pointer;
  position: absolute;
  right: 0;
}

.user-id span {
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.6;
  letter-spacing: normal;
  color: #1660ab;
  margin-left: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: -65px;
}

.head {
  border-bottom: 1px solid #1660ab;
  width: 100%;
  margin: 0;
  color: #1660ab !important;
  margin-bottom: 10px !important;
}

.box-info p {
  color: red;
  margin-top: 10px !important;
  font-size: 15px;
}

.service-board {
  width: 100%;
  padding: 10px 0;
  /* box-shadow: 0px 2px 8px 0 rgba(0, 0, 0, 0.2); */
  background: #fff;
  border-radius: 3px;
  overflow: auto;
  max-height: 350px;
  border: 1px solid #ccc;
  margin: 10px;
}

.service-header {
  text-align: center;
  font-size: 18px;
  color: #1660ab;
  padding: 5px 10px;
}

.service-body {
  text-align: justify;
  font-size: 13px;
  line-height: 1;
  padding: 10px;
}

.service-body p {
  margin-bottom: 0.4rem;
}

.txt-size p {
  margin: 0;
  margin-bottom: 5px !important;
  color: #ff0000;
}

.info-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
}

.error-modal-body {
  position: fixed;
  width: 1000px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  margin-top: 20px;
  padding-bottom: 30px;
  overflow-x: auto;
}

.title {
  float: left;
}

.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}

.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}

.box-text {
  padding-left: 40px;
}

.box-text p {
  margin: 0;
  border: none;
  color: black;
  font-size: 14px;
}

.box-text h2 {
  padding: 5px 0;
  font-size: 13px;
  margin: 0;
  color: black;
  font-weight: 500;
  line-height: 2;
}

.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}

.btn {
  background-color: #1660ab;
  color: #fff;
  padding: 3px 50px;
  margin-left: 16px;
}

.btn.redColor {
  background-color: #ed3237;
}

.top20 {
  margin-top: 20px;
}

.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}

.error-modal-body div p {
  margin: 0;
  padding: 5px 0;
}

.error-modal-body .error-img {
  margin-top: 37px !important;
  height: 49px;
  flex: 0.5;
  padding-left: 18px;
  line-height: 1.38;
}

.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}

.error-modal-body img {
  cursor: pointer;
}

.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}

.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.exitBtn {
  top: 0;
  right: 0;
  color: #fff;
  width: 32px;
  height: 32px;
  position: absolute;
}

.text-body h2 {
  text-align: center;
  font-size: 16px;
  padding-bottom: 10px;
}

.text-body p {
  font-size: 13px;
  text-align: justify;
}

.footer-text {
  margin: 0;
  padding: 0;
  padding-left: 40px;
}

.footer-text p {
  margin: 0;
  padding: 0;
  font-size: 13px;
  padding-bottom: 2px;
}

.footer-text i {
  color: #32cd32;
}

.imgDev {
  position: absolute;
  top: 0;
  left: 120px;
}

.imgDev img {
  height: 150px;
}

@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 10%;
    position: sticky;
  }
}

@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 10%;
    width: 80%;
    position: sticky;
  }
}

.bonus-transfer {
  margin: 0;
  padding: 10px 14px;
  border: 1px dashed #bdbdbd;
  margin-top: 14px;
}

.bonus-transfer p {
  margin: 0;
  font-size: 12px;
}

.colorRed {
  color: #ed3237;
}

.bonus-transfer b {
  color: #1660ab;
}

@media screen and (max-width: 767px) {
  .error-modal-body {
    width: 100%;
    top: 0;
  }

  .col-md-6 {
    width: 100%;
  }

  .col-md-4 {
    max-width: 100%;
  }

  .col-md-8 {
    max-width: 100%;
    padding-left: 10px;
  }

  .box-text h2 {
    font-size: 12px;
  }

  .box-text p {
    font-size: 12px;
  }

  .btn {
    padding: 5px 10px;
    font-size: 14px;
  }

  .service-board {
    padding: 0;
  }

  .service-confirm {
    text-align: left;
    line-height: 1.2em;
  }

  .user-id {
    flex-wrap: nowrap;
  }

  .box-text {
    padding-left: 30px;
  }
}
</style>
